<h1 class="mBottom2" *ngIf="formMode === 'create'; else titleEditUser">{{'USER_FORM.CREATE_USER' | translate}}</h1>
<ng-template #titleEditUser>
    <h1 class="mBottom2">{{'USER_FORM.EDIT_USER' | translate}}</h1>
</ng-template>

<form [formGroup]="userForm" (ngSubmit)="onSubmitForm(userForm.value)">

    <div class="inputForm">
        <mat-form-field appearance="outline">
            <mat-label>{{'USER_FORM.NAME'| translate}}</mat-label>
            <input type="text" matInput formControlName="name" />
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{'USER_FORM.FIRSTNAME'| translate}}</mat-label>
            <input matInput formControlName="firstName" />
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{'USER_FORM.USER'| translate}}</mat-label>
            <input matInput formControlName="user" />
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>{{'USER_FORM.EMAIL'| translate}}</mat-label>
            <input matInput formControlName="email" />
        </mat-form-field>
        
        <!-- <mat-form-field appearance="outline">
            <mat-label>{{'USER_FORM.PWD'| translate}}</mat-label>
            <input matInput formControlName="pwd" [type]="hide ? 'password' : 'text'"/>
            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility' : 'visibility_off'}}</mat-icon>
        </mat-form-field> -->




        <div class="row">
            <div class="col-3">
                <mat-form-field>
                    <mat-label>{{'USER_FORM.TIMEZONE'| translate}}</mat-label>
                    <mat-select (selectionChange)="changeTimeZone($event)" [(value)]="selectedOption" class="virtual-scroll">
                        <mat-option *ngFor="let timeZone of timezoneCollection"  [value]="timeZone" class="example-item">
                            {{timeZone}}
                            <div *ngIf="!timeZone">Loading...</div>
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div class="col-3" style="text-align: center;">
                <mat-label class="db">{{'USER_FORM.LANGUAGE'| translate}}</mat-label>
                <mat-radio-group aria-labelledby="example-radio-group-label" [color]="'primary'" formControlName="language">
                    <mat-radio-button class="rbAlarmState" [value]="'es'">{{'USER_FORM.ES'| translate}}</mat-radio-button>
                    <mat-radio-button class="rbAlarmState" [value]="'en'">{{'USER_FORM.EN'| translate}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div class="col-3" style="text-align: center;">
                <mat-label class="db">{{'USER_FORM.STATE'| translate}}</mat-label>
                <mat-radio-group aria-labelledby="example-radio-group-label" [color]="'primary'" formControlName="state">
                    <mat-radio-button class="rbAlarmState" [value]="'Activado'">{{'USER_FORM.ACTIVATED'| translate}}</mat-radio-button>
                    <mat-radio-button class="rbAlarmState" [value]="'Desactivado'">{{'USER_FORM.DEACTIVATED'| translate}}</mat-radio-button>
                </mat-radio-group>
            </div>
            <div *ngIf="isAdminUser()" class="col-1" style="text-align: center;" >
                <mat-label style="margin-bottom: 1em;" class="db">{{'USER_FORM.ADMIN'| translate}}</mat-label>
                <mat-checkbox [checked]="checkedAdmin" (click)="setAdminValue(checkboxAdminValue)"></mat-checkbox>
            </div>

        </div>

        <mat-label class="db">{{'USER_FORM.FACTORIES'| translate}}</mat-label>
       
        <div class="row">
            <div class="col-3" style="margin-bottom: 1.4em; height: 22rem;  overflow-y: auto;">
                <ul>
                    <li *ngFor="let factory of user.factories">{{factory.name}}</li>
                </ul>
            </div>
    
            <div class="col-3" style="margin-bottom: 1.4em; max-height: 22rem; overflow-y: auto;">
                <p *ngFor="let factory of factoryCollection">
                    <mat-checkbox [checked]="factory.selected" (change)="factorySelected(factory)">{{factory.name}}</mat-checkbox>
                </p>
            </div>
            <div class="col-3" style="margin-bottom: 1.4em; height: 22rem;  overflow-y: auto;">
                
                    <ng-container *ngIf="formMode === 'edit'; else createUserRoles">
                        <ul *ngFor="let rol of userToEdit.rol">
                            <li *ngIf="rol!='admin'">
                                {{"USER_FORM.ROLES.".concat(rol) | translate}}
                            </li>
                        </ul>
                    </ng-container>
                    <ng-template #createUserRoles>
                        <ul *ngFor="let rol of user.rol">
                            <li *ngIf="rol!='admin'">
                                {{"USER_FORM.ROLES.".concat(rol) | translate}}
                            </li>
                        </ul>
                    </ng-template>
            </div>

            <div class="col-3" style="margin-bottom: 1.4em; max-height: 22rem; overflow-y: auto;">
                <ng-container *ngIf="formMode === 'edit'; else createUserCheckedRoles">
                    <p *ngFor="let value of visualizations">
                        <mat-checkbox [checked]="userToEdit.rol.includes(value)" (change)="rolesSelected($event, value)">{{"USER_FORM.ROLES.".concat(value) | translate}}</mat-checkbox> 
                    </p>
                </ng-container>
                <ng-template #createUserCheckedRoles>
                    <p *ngFor="let value of visualizations">
                        <mat-checkbox [checked]="user.rol.includes(value)" (change)="rolesSelected($event, value)">{{"USER_FORM.ROLES.".concat(value) | translate}}</mat-checkbox> 
                    </p>
                </ng-template>
            </div>
        </div>

    </div>

    <button mat-raised-button (click)="cancelForm()">{{'DASHBOARD.FORM.CANCEL' | translate}}</button>
    <button mat-raised-button color="primary" class="right" [disabled]="isDataEmpty()" cdkFocusInitial
        type="submit">{{'DASHBOARD.FORM.ACCEPT' | translate}}</button>

</form>